/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortalMessage
 */
export interface PortalMessage {
    /**
     * 
     * @type {string}
     * @memberof PortalMessage
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalMessage
     */
    message?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PortalMessage
     */
    dismissable?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PortalMessage
     */
    type?: PortalMessageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PortalMessage
     */
    buttonUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalMessage
     */
    buttonText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalMessage
     */
    pathFilter?: string | null;
}


/**
 * @export
 */
export const PortalMessageTypeEnum = {
    Info: 'info',
    Error: 'error',
    SevereWarning: 'severeWarning',
    Warning: 'warning',
    Success: 'success'
} as const;
export type PortalMessageTypeEnum = typeof PortalMessageTypeEnum[keyof typeof PortalMessageTypeEnum];


/**
 * Check if a given object implements the PortalMessage interface.
 */
export function instanceOfPortalMessage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortalMessageFromJSON(json: any): PortalMessage {
    return PortalMessageFromJSONTyped(json, false);
}

export function PortalMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'dismissable': !exists(json, 'dismissable') ? undefined : json['dismissable'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'buttonUrl': !exists(json, 'buttonUrl') ? undefined : json['buttonUrl'],
        'buttonText': !exists(json, 'buttonText') ? undefined : json['buttonText'],
        'pathFilter': !exists(json, 'pathFilter') ? undefined : json['pathFilter'],
    };
}

export function PortalMessageToJSON(value?: PortalMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'message': value.message,
        'dismissable': value.dismissable,
        'type': value.type,
        'buttonUrl': value.buttonUrl,
        'buttonText': value.buttonText,
        'pathFilter': value.pathFilter,
    };
}

